import { render } from "./CompaniesWrapper.vue?vue&type=template&id=c8625fb0"
import script from "./CompaniesWrapper.vue?vue&type=script&lang=js"
export * from "./CompaniesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__